/** One step of the "how paying with an HSA/FSA works" walkthrough. */
export interface HsaLearnMoreStep {
  title: string;
  image: string;
}

/**
 * The walkthrough's steps. `requiresLmn` inserts the health-assessment step
 * before payment; step numbers are positional, so the payment step renumbers
 * itself. Kept free of CSS/JSX imports so it is testable on its own.
 */
export function hsaLearnMoreSteps(requiresLmn: boolean): HsaLearnMoreStep[] {
  return [
    { title: "Checkout as guest", image: "checkout-as-guest.png" },
    {
      title: "Select HSA/FSA at checkout",
      image: "hsa-fsa-payment-method.png",
    },
    ...(requiresLmn
      ? [{ title: "Complete a health assessment", image: "health-survey.png" }]
      : []),
    {
      title: "Pay with HSA/FSA or credit card",
      image: "portal-payment-ui.png",
    },
  ];
}
